module.exports = __webpack_public_path__ + "img/trainingCenter-bg02.7fcbc8e3.png";